var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 40C0 17.909 17.909 0 40 0s40 17.909 40 40-17.909 40-40 40S0 62.091 0 40z",
    fill: "#010101"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.165 35.33v-1.715a12.63 12.63 0 00-1.799-.155 13.337 13.337 0 00-7.645 24.285 13.323 13.323 0 019.444-22.416z",
    fill: "#69C9D1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.488 54.75a6.1 6.1 0 006.086-5.832V19.841h5.312A9.973 9.973 0 0147.73 18h-7.265v29.05a6.1 6.1 0 01-6.086 5.873 6.183 6.183 0 01-2.81-.702 6.099 6.099 0 004.918 2.53zM57.807 29.706V28.09a9.921 9.921 0 01-5.495-1.658 10.076 10.076 0 005.495 3.274z",
    fill: "#69C9D1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.313 26.432a10.007 10.007 0 01-2.488-6.605h-1.94a10.062 10.062 0 004.428 6.605zM34.366 40.725a6.1 6.1 0 00-2.81 11.496 6.086 6.086 0 014.932-9.655c.61.008 1.216.102 1.8.281v-7.392a12.743 12.743 0 00-1.8-.14h-.323v5.621a6.252 6.252 0 00-1.799-.21z",
    fill: "#EE1C51"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.808 29.707v5.621a17.245 17.245 0 01-10.077-3.274v14.77c-.015 7.37-5.995 13.337-13.365 13.337a13.225 13.225 0 01-7.645-2.417 13.337 13.337 0 0023.104-9.078V33.937a17.273 17.273 0 0010.09 3.233v-7.238a10.294 10.294 0 01-2.107-.225z",
    fill: "#EE1C51"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.731 46.824v-14.77a17.244 17.244 0 0010.09 3.232v-5.621a10.077 10.077 0 01-5.508-3.233c-2.32-1.5-3.92-3.889-4.427-6.605h-5.312v29.091A6.099 6.099 0 0131.54 52.25a6.1 6.1 0 012.811-11.496c.61.005 1.216.1 1.8.281v-5.621a13.323 13.323 0 00-9.445 22.486 13.224 13.224 0 007.66 2.262c7.37 0 13.349-5.966 13.364-13.337z",
    fill: "#FEFEFE"
  })));
}
export default SvgTiktok;